import { Card, CardContent } from "@/components/ui/card";

const RING_BY_ACCENT = {
  blue: "border-blue-200",
  emerald: "border-emerald-200",
};
const TITLE_BY_ACCENT = {
  blue: "text-blue-700",
  emerald: "text-emerald-700",
};

export const ComparisonSide = ({ name, price, pros, cons, accent, side }) => {
  const ring = RING_BY_ACCENT[accent] || RING_BY_ACCENT.blue;
  const titleColor = TITLE_BY_ACCENT[accent] || TITLE_BY_ACCENT.blue;
  const testId = side ? `comparison-side-${side}` : undefined;
  return (
    <Card className={`border-2 ${ring} h-full`} data-testid={testId}>
      <CardContent className="p-6">
        <h3 className={`text-xl font-bold ${titleColor} mb-2`}>{name}</h3>
        <p className="font-semibold text-slate-800 mb-4">{price}</p>
        <div className="mb-4">
          <p className="font-semibold text-slate-900 mb-2">Avantages</p>
          <ul className="space-y-1 text-sm text-slate-700">
            {pros.map((p) => <li key={p}>• {p}</li>)}
          </ul>
        </div>
        <div>
          <p className="font-semibold text-slate-900 mb-2">Inconvénients</p>
          <ul className="space-y-1 text-sm text-slate-700">
            {cons.map((c) => <li key={c}>• {c}</li>)}
          </ul>
        </div>
      </CardContent>
    </Card>
  );
};
